import { FormikHelpers } from "formik";
import { useCreateLine } from "./api/createLine";
import CreateLineForm from "./CreateLineForm";


const CreateLine = ({handleCloseModal}: CreateLineProps)  => {
  const createLineMutation = useCreateLine({data: {}});

  const initialValues: ICreateLineForm = {
    applProtocolNumber: "",
    applDate: "",
    offApplDate: "",
    deliveryDate: "",
    pendingStatusID: "",
    providerID: "",
    lineTypeID: "",
    comments: "",
    usedByID: "",
    sapCode: "",
    isEmporiki: false,
    isCiti: false,
    lineType: 2,
    costByID: "",
    speedID: "",
    cost: "",
    endA: "",
    endB: "",
    hcNmsNum: "",
    hcNum1: "",
    hcNum2: "",
    accNum1: "",
    accNum2: "",
    coupleNumA1: "",
    coupleNumB1: "",
    coupleNumA2: "",
    coupleNumB2: "",
    phoneNumber: "",
    descline: ""
  };

  const handleSubmit = async (values: ICreateLineForm, { setSubmitting }: FormikHelpers<ICreateLineForm>): Promise<void> => {
    try {
      await createLineMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CreateLineForm initialValues={initialValues} onSubmit={handleSubmit} />
  )
}

interface CreateLineProps {
  handleCloseModal: () => void;
}

export default CreateLine;